// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Logo[data-v-11580f7e]{font-weight:900;font-size:1.25em}.Logo img[data-v-11580f7e]{height:25px;width:auto;margin-right:2px}.Logo[data-v-11580f7e]:hover{text-decoration:none}.Logo .main[data-v-11580f7e]{color:#727cf5}.Logo .dark[data-v-11580f7e]{color:#282f3a}.Logo .regular[data-v-11580f7e]{color:#828a98}.Logo .light[data-v-11580f7e]{color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
